<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2199_5002)">
<path d="M15.9831 31.9662C24.8103 31.9662 31.9662 24.8103 31.9662 15.9831C31.9662 7.15588 24.8103 0 15.9831 0C7.15588 0 0 7.15588 0 15.9831C0 24.8103 7.15588 31.9662 15.9831 31.9662Z" fill="#68706D"/>
<g clip-path="url(#clip1_2199_5002)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.9999 6.83325C18.3011 6.83325 20.1666 8.69873 20.1666 10.9999V18.4999H17.6666C14.4449 18.4999 11.8333 15.8882 11.8333 12.6666V10.9999C11.8333 8.69873 13.6987 6.83325 15.9999 6.83325ZM13.0833 12.6666V11.4166H15.9999C16.6903 11.4166 17.2499 11.9762 17.2499 12.6666V17.2312C14.9139 17.0207 13.0833 15.0574 13.0833 12.6666Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M25.0323 23.9166C24.4601 21.2956 22.1259 19.3333 19.3333 19.3333H12.6666C9.87399 19.3333 7.53972 21.2956 6.96749 23.9166C6.87958 24.3193 6.83325 24.7375 6.83325 25.1666H25.1666C25.1666 24.7375 25.1203 24.3193 25.0323 23.9166Z" fill="white"/>
</g>
</g>
<defs>
<clipPath id="clip0_2199_5002">
<rect width="32" height="32" fill="white"/>
</clipPath>
<clipPath id="clip1_2199_5002">
<rect width="20" height="20" fill="white" transform="translate(6 6)"/>
</clipPath>
</defs>
</svg>
